<template>
  <validation-provider
    v-if="isUserKeepMeSignIn"
    v-slot="{ failed }"
    :vid="`${stepId}_user-keep-sign-in`"
    name="Outbound"
    rules="required"
  >
    <div class="d-flex align-center mt-4 user-keep-sign-in-small">
      <checkbox-square
        v-model="questionData.userKeepSignIn"
        :name="`${stepId}.user_keep_sign_in`"
        :error="failed"
        data-test="user-keep-sign-in"
      />
      <div class="ml-4 d-flex align-center">
        <span
          class="user-keep-sign-in-small__title mr-1 font-weight-bold"
          v-html="keepMeSignedInText.title"
        />
        <qz-tooltip
          v-if="keepMeSignedInText.helpText"
          bottom
        >
          <template #tooltip-body>
            <span
              v-html="keepMeSignedInText.helpText"
            />
          </template>
        </qz-tooltip>
      </div>
    </div>
  </validation-provider>
</template>

<script>
import UserKeepSignIn from '@/components/questions/UserKeepSignIn';
export default {
  name: 'user-keep-sign-in-small',
  extends: UserKeepSignIn,
};
</script>

<style scoped lang="scss">
.user-keep-sign-in-small {
  &__title {
    font-size: 1rem;
  }

  &::v-deep {
    .checkbox__container {
      padding: 6px;
    }

    .checkbox__icon {
      width: 14px;
      height: 14px;

      &::after {
        width: 6px;
        height: 6px;
      }
    }
  }
}
</style>
